import service from '@/config/axios'
export function getVersionInfo() {
  return service({
    url: '/api/system/messages/get',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/version.js